import { Component, Input } from "@angular/core";
import { Controparte } from "../../models/controparte";

@Component({
  selector: 'app-associativa-controparti',
  templateUrl: 'associativa-controparti.component.html'
})

export class AssociativaContropartiComponent {
  @Input() controparte: Controparte;
}
